<div class="language-selection-dialog">
  <!-- Close button -->
  <button class="language-selection-dialog__close" (click)="onCancel()" type="button" aria-label="Close">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="12" fill="#96080B"/>
      <path d="M16 8L8 16M8 8L16 16" stroke="white" stroke-width="2" stroke-linecap="round"/>
    </svg>
  </button>

  <div class="language-selection-dialog__content">
    <div class="language-selection-dialog__form-group">
      <!-- Title -->
      <h2 class="language-selection-dialog__title">{{ translationNs + '.choose_language_title' | translate }}</h2>

      <!-- Language Dropdown -->
      <div class="language-selection-dialog__dropdown">
        <select
          class="language-selection-dialog__select"
          [(ngModel)]="selectedLanguage"
          [disabled]="isLoading"
          required>
          <option [ngValue]="null" disabled selected>
            {{ isLoading ? (translationNs + '.loading_languages' | translate) : (translationNs + '.please_choose_option' | translate) }}
          </option>
          <option *ngFor="let language of languages" [ngValue]="language">
            {{ language.name }}
          </option>
        </select>
        <svg class="language-selection-dialog__dropdown-icon" width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
          <path d="M7 10l5 5 5-5z"/>
        </svg>
      </div>

      <!-- Helper text -->
      <p class="language-selection-dialog__helper">
        {{ translationNs + '.multiple_languages_helper' | translate }}
      </p>
    </div>

    <!-- Confirm Button -->
    <button
      class="language-selection-dialog__confirm"
      [disabled]="!selectedLanguage || isLoading"
      (click)="onConfirm()">
      {{ translationNs + '.confirm_button' | translate }}
    </button>
  </div>
</div>
